import React from "react";
import "./BackButton.scss";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import { withRouter, RouteComponentProps } from "react-router";
import { Button } from "@material-ui/core";

interface IProps extends RouteComponentProps<any> {
  backHandler?: () => void;
}

function BackButton(props: IProps) {
  function backHandler() {
    if (props.backHandler) {
      props.backHandler();
    } else {
      props.history.goBack();
    }
  }
  return (
    <div className="page-back" onClick={backHandler}>
      <Button className="button" startIcon={<KeyboardArrowLeftIcon />}>
        Back
      </Button>
    </div>
  );
}

export default withRouter(BackButton);
